module.exports = {
    language: "日语",

    xtc: {
        agreement: "購入は{service}および{privacy}に同意したものとみなされます",
        service: "サービス協定",
        privacy: "プライバシーポリシー",
        agreementAlert: "まずサービス協定とプライバシーポリシーに同意してください。",
        pro: "メンバー限定特典",
        proDesc: "メンバーは無制限の会話を楽しみ、翻訳機能を利用できます",
        image: "最大3枚の画像をアップロードできます",
    },
    setting: {
        index: {
            title: "設定",
            problem: "問題のフィードバック",
            order: "注文記録",
            notice: "お知らせ",
            language: "言語",
            clear: "キャッシュをクリア",
            clearTip: "キャッシュをクリアしますか？\n",
            confirm: "確認",
            cancel: "キャンセル",
        },
        language: {
            title: "言語",
            langList: ["簡体字中国語", "繁体字中国語", "英語", "アラビア語", "ポーランド語", "ペルシア語", "デンマーク語", "ドイツ語", "ロシア語", "フランス語", "オランダ語", "チェコ語", "ルーマニア語", "ポルトガル語", "日本語", "タイ語", "トルコ語", "スペイン語", "ギリシャ語", "イタリア語", "ベトナム語", "ヒンディー語", "韓国語", "インドネシア語", "マレー語", "ベンガル語", "ヘブライ語", "ウクライナ語", "クメール語", "スロバキア語", "ハンガリー語", "スロベニア語", "ブルガリア語", "クロアチア語"],
        },
        order: {
            title: "注文記録",
            success: "取得成功",
            unpaid: "未払い",
            paid: "支払い済み",
            expired: "期限切れ",
            refunded: "返金済み",
            review: "審査中",
            failed: "返金失敗",
            payFailed: "支払い失敗",
            pTime: "支払い時間",
            eTime: "有効期限",
            pMethod: "支払い方法",
            pObject: "支払い対象",
            oNumber: "注文番号",
            pType: "パッケージ種類",
            oTime: "取得時間",
            watch: "IMEIを表示",
            delete: "注文を削除",
            refund: "返金を申請",
            invoice: "請求書",
            empty: "まだ記録がありません",
            grade: "パッケージレベル",
            package: "パッケージ状態",
            use: "利用状況",
            remaining: "パッケージ数量",
            basic: "ベーシック",
            pro: "プロ",
            refundAmount: "返金額",
        },
        invoice: {
            invoice: "Jarvis の請求書",
            download: "請求書をダウンロード",
            from: "差出人",
            to: "宛先",
            memo: "メモ",
            thank: "ご利用ありがとうございます！",
            draft: "下書き",
            amount: "支払金額",
        },
        problem: {
            title: "問題のフィードバック",
            feedback: "フィードバック種類",
            please: "選択してください",
            content: "内容",
            improve: "機能要望、製品への不満などご提案をご記入ください。改善に努めます。",
            upload: "画像をアップロード",
            submit: "送信",
            general: "一般的なフィードバック",
            purchase: "購入関連",
            bug: "バグ報告",
            suggestion: "提案",
            other: "その他",
        },
        notice: {
            title: "お知らせ",
            type: "通知タイプ：システム返信",
            time: "通知時間："
        }
    },
    subscription: {
        jarvis: {
            funcList: ["AI Q&A", "AIお絵描き", "基本版スマートAI", "高度スマートAI", "マルチモーダル入出力", "より詳細なQ&A", "より賢いモデル", "より高速な応答"],
            times: "回",
            days: "日",
            more: "より高度なAI",
            custom: "カスタムウォッチ用スマートAIリスト",
            delay: "アカウントへの反映に多少の遅延が発生する場合があります。少しお待ちいただき、ウォッチアプリを終了して再入場してください。",
            member: "メンバー比較",
            packageName: "パッケージ名",
            unlimited: "無制限",
            month: "月",
            paySuccess: "支払い成功",
        },
        index: {
            nav: {
                l: "プロ",
                r: "回数",
                language: "言語",
                notice: "お知らせ",
                feedback: "フィードバック",
            },
            proBox: {
                expire: {
                    title: "有効期限",
                    date: "まだ購読していません",
                },
                packTip: "3種類の月額パッケージがあります",
                packList: ["最上位サブスクリプション", "ベーシックサブスクリプション", "通常サブスクリプション"],
                benefit: {
                    origin: "定価：",
                    remaining: "残り",
                    title: "サブスクリプション特典",
                    value: "価値",
                    benefitList: [
                        { labelTime: "回数無制限", labelSave: "画像保存", labelPer: "全権限" },
                        { labelTime: "300回", labelSave: "記録保存", labelPer: "基本権限" },
                        { labelTime: "100回", labelSave: "記録保存", labelPer: "低権限" },
                    ],
                    desc: "$3.99/月で100回無料、$9.99/月で300回無料が付与されます。",
                    tip: "回数の反映に少し遅延が発生する場合があります。しばらくお待ちいただき、ウォッチアプリを終了して再入場してください。"
                },
            },
            timeBox: {
                packTip: "3種類の月額パッケージがあります",
                packList: ["新規ユーザー割引回数パック", "50回パック", "100回パック", "300回パック"],
                times: {
                    title: "回数の役割",
                    timesList: ["お絵描きに使用", "GPT Q&Aに使用", "星座占いに使用", "学習に使用", "物体認識に使用"],
                    desc: "50回 $2.99、100回 $4.99、300回 $12.99。$0.99の50回パックは新規ユーザー向けで1回のみ購入可能（24時間以内有効）。",
                }
            },
            staticBox: {
                confirm: "確認",
                privacy: "プライバシー",
                terms: "利用規約",
                refund: "返金",
                cancel: "いつでも解約可能",
                funcTitle: "PRO体験で創造性を解き放とう",
                function: "機能",
                free: "無料",
                pro: "プロ",
                funcList: ["回数は1日有効", "10回 描画/チャット（3回の有効化チャンス）", "1回の購読で30日", "より多くの利用回数", "画像を永久保存", "購入可能な回数"],
                details: "詳細",
            },
            dialog: {
                error: "支払いが利用できません。ウォッチのQRコードをスキャンしてください。",
                unbind: "支払いアカウントを変更中です。続行しますか？",
                beforePay: "現在のアカウントで支払いを続行しますか",
                renewal: "自動更新を有効にしますか",
                confirm: "確認",
                cancel: "キャンセル",
                change: "変更/連携",
                beforeConsent: "この商品を購読しています",
            }
        },
        NewIndex: {
            l: "ベーシック",
            r: "プロ",
            proBox: {
                benefit: {
                    title: "パッケージ内容",
                    benefitList: [
                        { labelTime: "獲得回数", labelSave: "通常回数" },
                        { labelTime: "獲得回数", labelSave: "プロ回数" },
                        { labelTime: "機能解放", labelSave: "すべての通常機能を解放" },
                        { labelTime: "機能解放", labelSave: "すべてのプレミアム機能を解放" },

                    ]
                }
            },
            funcList: ["Q&A", "AIお絵描き", "基本版スマートAI", "高度スマートAI", "テキスト読み上げ", "より詳細な返信", "より高速な応答"],
            confirm: '今すぐアップグレード',
            dialog: {
                beforePay: "通常会員を購読中です。プレミアム会員を追加購入すると、通常会員の実際の利用分に応じて返金されます。続行しますか？",
            },
            licenseBox: {
                navTitle: "アップグレードパッケージを購入",
                title: "アップグレードパッケージの特典",
                func: [
                    {
                        label: "回数の獲得",
                        value: "取得可能",
                        value2: "回の高度利用枠"
                    },
                    {
                        label: "機能解放",
                        value: "高度利用はすべての高度機能にアクセス可能"
                    },
                    {
                        label: "共有利用",
                        value: "高度モード有効化後、全機能で高度利用枠を共有"
                    },
                ],
                funLevel: {
                    title: "機能アップグレード",
                    funs: [
                        {
                            label: "返信最適化",
                            value: "返信品質の向上、応答速度の向上、返信文字数上限の引き上げ"
                        },
                        {
                            label: "写真認識",
                            value: "写真認識の権限を解放し、写真認識機能を利用可能に"
                        },
                        {
                            label: "テキスト読み上げ",
                            value: "TTS権限を解放し、返信テキストを音声再生可能に"
                        }
                    ]
                }
            }
        },
        zw: {
            member: "メンバーシップを購入",
            min: "分",
            expire: "有効期間：{0}日",
        },
        qw: {
            func: "機能紹介",
            func1: "超長時間の分数！",
            func2: "2時間の長時間会議に対応！",
            func3: "ワンクリックで議事録を生成！",
            func4: "会議を賢く章分け！",
            func5: "ToDo項目を賢く抽出！",
            func6: "ワンクリックでマインドマップ生成！",
            func7: "複数形式で会議をエクスポート！",
            buy: "今すぐ購入",
            pullUp: "お支払いが完了しました。これで{name}を開いて、さらに多くの機能をご利用いただけるようになります。",
            tips: "本製品はサブスクリプション製品であり、有効期限が切れると自動的に更新されます",
            paymentFailed: "支払いに失敗しました",
            unsubscribeSuccess: "購読の解除に成功しました。",
            effectiveOrder: "有効な注文",
            expireOrder: "期限切れの注文",
            submitSuccess: "送信に成功しました。",
            emailError: "メールフォーマットが無効です。",
            payTimeout: "注文ページをご覧ください。",
            confirmText: "確認すると、HONG KONG ADFLASH MEDIA LIMITED がその規約に基づき、このカードに現在および今後の支払いを請求することを承認したものとみなされます。"
        },
        unsubscribe: {
            title: "サブスクリプションの解約",
            subTitle: "継続購読",
            unsubscribe: "解約する",
            subscribeTime: "購読時間",
            cardBind: "カード連携に成功しました",
            cardBindDesc: "お支払いアカウントが正常に追加されました",
            empty: "購読記録がありません",
        },
        refund: {
            title: "返金を申請",
            number: "注文番号",
            content: "返金理由をご説明ください",
            empty: "送信できません。必須項目が空です。",
        },
        order: {
            number: "注文番号",
            name: "注文名",
            times: "注文回数",
            validity: "回数の有効期間",
            buy: "今すぐ購入",
            days: "日",
            unlock: "すべてのスマートAIを解放",
            text: "テキスト読み上げ",
            tips: "これはサブスクリプション商品です。購入後、デフォルトで購読が開始されます。",
        },
        zhzn: {
            l: "お絵描き",
            r: "Q&A",
            isCard: "支払いアカウントを連携してください",
            subscription: "現在の商品はサブスクリプション商品です",
            title: "メンバー特典",
            t1: "音声認識",
            d1: "音声をテキストに変換し、便利で効率的なコミュニケーションを実現。",
            t2: "画像生成無制限",
            d2: "無制限の画像生成で創造力を解放。迅速かつ便利。",
            t3: "文字盤設定",
            d3: "文字盤をカスタマイズして時間や情報を個性的に表示。",
            t4: "オンライン検索",
            d4: "リアルタイムで情報を取得し、必要な答えを素早く発見。",
            t5: "情報検索",
            d5: "迅速に検索し、正確な情報と回答を提供。",
        }
    },
    payment: {
        index: {
            contact: "連絡先",
            please: "メールアドレスを入力してください",
            email: "支払いの領収書はこのメールに送信されます",
            name: "カード名義",
            firstName: "名",
            lastName: "姓",
            confidence: "当社はお客様の情報を保持しません。安心してご入力ください",
            Card: "カード情報",
            confirm: "サブスクリプションを確認すると、規約に従い今後の支払いのためにJarvisがカードから引き落とすことに同意したものとみなされます。サブスクリプションはいつでも解約できます。",
            powered: "Powered by Stripe",
            terms: "利用規約",
            privacy: "プライバシー",
        }
    },
    policy: {
        title: {
            terms: "利用規約",
            about: "概要",
            service: "サービス規約",
            privacy: "プライバシーポリシー",
            refund: "返金ポリシー",
            us: "私たちについて",
        },
        service: {
            section1: `<p>https://aiwatchstore.org/ にあるウェブサイトは、HONG KONG ADFLASH MEDIA LIMITED に属する著作物です。サイトの特定の機能は追加のガイドライン、規約、ルールに従う場合があり、その機能に関連してサイト上に掲示されます。</p>
            <p>これらすべての追加規約、ガイドライン、ルールは本規約に組み込まれます。</p>
            <p>本利用規約は、サイトの利用を管理する法的拘束力のある条件を定めます。サイトにログインすることで、本規約に同意し、本規約を締結する権限と能力があることを表明します。サイトへアクセスするには18歳以上である必要があります。すべての条項に同意しない場合、ログインおよび/またはサイトの使用を行わないでください。</p>
            <p>本規約は、紛争解決のため個別の仲裁（第10.2節）の利用を求め、紛争時に利用可能な救済を制限します。</p>
            <h2>サイトへのアクセス</h2>
            <p><strong>本規約に従うこと。</strong>当社は、個人的かつ非商用目的に限りサイトへアクセスする、譲渡不可・非独占的・取り消し可能な限定ライセンスを付与します。</p>
            <p>当社は予告の有無にかかわらず、サイトを変更、一時停止、または停止する権利を留保します。これにより発生する変更、中断、終了について、当社はお客様または第三者に対して責任を負いません。</p>
            <p><strong>サポートや保守なし。</strong>当社はサイトに関してサポートの義務を負わないものとします。</p>
            <p>お客様が提供するユーザーコンテンツを除き、サイトおよびそのコンテンツに関するすべての知的財産権（著作権、特許、商標、営業秘密を含む）は当社または当社のサプライヤーに帰属します。本規約およびサイトへのアクセスは、第2.1節に明示された限定的なアクセス権を除き、知的財産権に関するいかなる権利も付与しません。当社とサプライヤーは、本規約で付与されていないすべての権利を留保します。</p>`,
            section2: `<h2>サブスクリプション規約</h2>
            <p>当社のサブスクリプションサービス（以下「サービス」）へようこそ。本サービスは HONG KONG ADFLASH MEDIA LIMITED（以下「当社」）が提供します。本サービスを利用・購読することで、本サブスクリプション規約（以下「規約」）に従うことに同意したものとみなされます。</p>
            <p>当社は、独自のユーザー枠を含むサブスクリプション型サービスを提供します。具体的な内容や料金は随時変更され、メールまたは当社ウェブサイトで通知・更新されます。</p>
            <p>料金、支払い方法、サイクルは価格ページに記載しています。滞納があるアカウントは有料サービスが一時停止されます。</p>
            <p>すべてのサブスクリプション料金は、法令により必要な場合または当社の裁量による場合を除き返金不可です。</p>
            <p>お客様はいつでも解約できます。解約後も現在の期間終了まではサービスを提供しますが、既払い料金は返金されません。</p>
            <p>以下の場合、当社は一方的にサービスを終了・停止できます：</p>
            <p>- 本規約違反</p>
            <p>- 料金未払い</p>
            <p>当社は高品質なサービスに努めますが、可用性、正確性、完全性について明示・黙示のいかなる保証もしません。</p>`,
            section3: `<h2>他のユーザー</h2>
            <p><strong>他のユーザー。</strong>各ユーザーは自らのユーザーコンテンツに単独で責任を負います。当社はユーザーコンテンツを管理しないため、当社はユーザーコンテンツについて一切責任を負いません。ユーザー間のやり取りに起因する損失や損害について、当社は責任を負いません。ユーザー間の紛争に当社は関与する義務を負いません。</p>
            <p>お客様は、当社および当社の役員、従業員、代理人、承継人、譲受人を、サイトに直接・間接的に起因または関連する一切の請求・紛争から免責・放免します。カリフォルニア州居住者は、以下の民法第1542条を放棄します：「一般的な免除は、債権者が免除時に自らに有利に存在すると知らず、または疑わなかった請求には及ばない。もし知っていれば、債務者との和解に重大な影響を与えていたであろう。」</p>
            <p><strong>クッキーとウェブビーコン。</strong>当サイトは他のサイト同様に「クッキー」を使用します。クッキーは訪問者の好みやアクセスしたページ等の情報を保存します。これらはブラウザタイプ等に基づきコンテンツを最適化するために使用されます。</p>
            <h2>免責事項</h2>
            <p>本サイトは「現状有姿」かつ「提供可能な状態」で提供され、当社およびサプライヤーは、商品性、特定目的適合性、権原、静穏享受、正確性、非侵害等の一切の明示・黙示・法定の保証を否認します。当社は、サイトが要求を満たすこと、中断なく安全かつエラーなしで提供されること、正確・信頼できること、ウイルス等がないこと、完全・合法・安全であることを保証しません。適用法により保証が必要な場合、その期間は初回使用日から90日間に限定されます。</p>
            <p>一部法域では黙示保証の除外が認められないため、上記が適用されない場合があります。期間制限の制限も同様です。</p>`,
            section4: `<h2>責任の制限</h2>
            <p>法で許される最大限の範囲で、当社またはサプライヤーは、本規約またはサイトの利用・不能に起因する逸失利益、データ損失、代替品調達費用、間接・結果的・模範的・付随的・特別・懲罰的損害について、可能性を通知されていても責任を負いません。サイトへのアクセス・利用はお客様の裁量とリスクであり、機器・システムの損害やデータ損失は自己責任です。</p>
            <p>当社の責任は、本契約に関連して発生する損害について、常に最大50米ドルに限定されます。請求が複数でも上限は拡大しません。サプライヤーは本契約に関連していかなる責任も負いません。</p>
            <p>一部法域では付随的・結果的損害の制限/除外が認められないため、適用されない場合があります。</p>
            <p><strong>期間と終了。</strong>本規約はサイト使用中有効です。当社は単独の裁量で、いつでも本規約違反等を理由に使用権を停止・終了できます。終了時、アカウントとアクセス権は直ちに終了し、ユーザーコンテンツが削除される場合があります。当社は一切責任を負いません。終了後も、第2～2.5節、第3節および第4～10節は有効です。</p>
            <p></p>
            <p>補償。お客様は、サービスの利用、コンテンツ、サービスに関連して開発・提供する製品やサービス、本規約違反、適用法違反に起因する請求・損失・費用（弁護士費用を含む）から、当社等を防御・補償・免責するものとします。</p>
            <p>免責。サービスは「現状有姿」で提供されます。法で禁止されない限り、当社および関連会社・ライセンサーは、商品性、特定目的適合性、満足品質、非侵害、静穏享受、取引慣行に基づく保証等を否認し、中断・正確・無誤・安全・未喪失・未改変を保証しません。</p>`,
            section5: `<h2>著作権ポリシー。</h2>
            <p>当社は他者の知的財産を尊重し、ユーザーにも同様の行動を求めます。著作権法に基づき、侵害資料の削除および反復侵害者のアカウント終了の方針を採用しています。ユーザーがサイトを通じて違法に著作権を侵害しているとお考えの場合、以下の情報を含む書面通知（17 U.S.C. § 512(c)）を当社指定の著作権代理人に提出してください：</p>
            <p>- 物理または電子署名</p>
            <p>- 侵害されたと主張する著作物の特定</p>
            <p>- 削除を求める侵害資料の当社サービス上の位置の特定</p>
            <p>- 当該資料の位置を特定するのに十分な情報</p>
            <p>- 住所、電話番号、メールアドレス</p>
            <p>- 異議対象の使用が権利者、代理人、または法律により許可されていないと誠実に信じる旨の陳述</p>
            <p>- 通知の情報が正確であり、偽証の罰則の下で、権利者または権利者の代理であることの陳述</p>
            <p>17 U.S.C. § 512(f) に従い、書面通知で重要な事実を虚偽記載した場合、当社が被った損害、費用、弁護士費用に対して責任を負うことに注意してください。</p>`,
            section6: `<h2>一般</h2>
            <p>本規約は随時改定される場合があり、重要な変更がある場合は、最後に提供されたメール宛てに通知するか、サイト上で顕著に告知します。最新のメールアドレスの提供はお客様の責任です。無効なメールアドレスであっても、送信により通知の効力が生じます。変更は、メール送信後30日またはサイト告知後30日の早い方で有効となります。新規ユーザーには即時適用されます。変更通知後にサイトを継続利用することは、変更の承認および拘束に同意したことを意味します。紛争解決：本仲裁合意をよくお読みください。これはお客様の権利に影響し、強制的な拘束力のある仲裁および集団訴訟の放棄を含みます。</p>
            <p><strong>仲裁合意の適用範囲。</strong>非公式解決または少額裁判所で解決できない、本規約または当社の製品・サービスの利用に関するすべての請求・紛争は、個別の拘束力ある仲裁で解決します。別段の合意がない限り、仲裁手続は英語で行われます。本合意はお客様と当社、その子会社、関連会社、代理人、従業員、前任者、承継人、譲受人、ならびに認可の有無を問わず受益者に適用されます。</p>
            <p><strong>通知要件と非公式紛争解決。</strong>仲裁前に、当事者はまず紛争の性質と根拠、救済を記載した書面による紛争通知を相手方に送付しなければなりません。通知受領後30日以内に解決されない場合、仲裁を開始できます。仲裁人が裁定額を決定するまで、和解提案額は開示されません。</p>
            <p><strong>仲裁規則。</strong>仲裁はAAAを通じて開始します。AAAが利用できない場合、代替ADR提供者を選定します。ADRの規則は本規約と矛盾しない限り適用されます。AAA消費者仲裁規則は adr.org で入手できます。単独の中立仲裁人が実施します。1万米ドル未満の請求は、申立人の選択で出廷不要の仲裁で解決できます。1万米ドル以上は規則に従い審理の有無が決定されます。審理は居住地から100マイル以内で行われます（米国外居住の場合は別途通知）。裁定は有効な裁判所に登記できます。仲裁前の当社の最後の和解提案より大きい裁定を受けた場合、当社は裁定額または$2,500のいずれか高い方を支払います。各当事者は自己費用を負担し、ADR費用は折半します。</p>
            <p><strong>非出廷型仲裁の追加規則。</strong>電話、オンライン、書面のみで実施できます。当事者の合意がない限り、対面出廷はありません。</p>
            <p><strong>時効。</strong>仲裁は関連する時効およびAAA規則の期限内に開始する必要があります。</p>
            <p><strong>仲裁人の権限。</strong>仲裁人は当事者の権利と責任を判断し、他案件との併合は行いません。金銭的損害および法で可能な非金銭的救済を付与できます。書面裁定を行い、裁判官と同等の権限を有します。裁定は最終的かつ拘束力があります。</p>
            <p><strong>陪審裁判の放棄。</strong>当事者は裁判所および陪審裁判の権利を放棄し、仲裁で解決することに同意します。</p>
            <p><strong>集団または併合訴訟の放棄。</strong>範囲内のすべての請求・紛争は個別にのみ仲裁または訴訟され、他ユーザーの請求と共同・併合できません。</p>
            <p><strong>機密保持。</strong>仲裁手続のすべての側面は厳格に機密です。法で要求される場合を除き秘密を保持します。</p>`,
            section7: `<p><strong>可分性。</strong>本仲裁合意の一部が無効・執行不能と判断された場合、その部分は切り離され、残りは引き続き有効です。</p>
            <p><strong>放棄の権利。</strong>本仲裁合意の権利および制限は、請求の相手方が放棄できますが、他部分には影響しません。</p>
            <p><strong>存続。</strong>本仲裁合意は関係終了後も存続します。</p>
            <p><strong>少額裁判所。</strong>いずれの当事者も少額裁判所に個別の訴えを提起できます。</p>
            <p><strong>緊急衡平救済。</strong>いずれの当事者も仲裁の前に地位を維持するため、州または連邦裁判所に緊急救済を求めることができます。</p>
            <p><strong>仲裁対象外の請求。</strong>名誉毀損、CFAA違反、特許・著作権・商標・営業秘密の侵害または不正流用の請求は仲裁対象外です。</p>
            <p>裁判を許容する状況では、当事者はカリフォルニア州ネーデルランズ郡所在の裁判所の人的管轄に服することに同意します。</p>
            <p>サイトは米国の輸出管理法の対象となる場合があります。お客様は、米国輸出法規に違反して技術データやそれを利用する製品を輸出・再輸出・移転しないことに同意します。</p>`,
            section8: `<p><strong>電子的通信。</strong>お客様と当社の通信は電子手段を用います。契約上の目的で、(a) 当社からの電子的な通信の受領に同意し、(b) 当社が電子的に提供する条件・契約・通知・開示等が書面の法的要件を満たすことに同意します。</p>
            <p><strong>完全合意。</strong>本規約はサイト利用に関する完全な合意です。権利不行使は放棄を意味しません。見出しは便宜上のもので法的効力はありません。「含む」は「制限なく含む」を意味します。条項が無効・執行不能な場合、法の許す最大限で有効となるよう修正されたものとみなします。当社とお客様は独立した契約関係であり、代理でもパートナーでもありません。当社の事前書面同意なく権利義務を譲渡・委託・移転できず、違反時は無効です。当社は自由に譲渡できます。本規約は譲受人を拘束します。</p>
            <p><strong>プライバシー。</strong>当社のプライバシーポリシーをお読みください。</p>
            <p><strong>著作権/商標情報。</strong>Copyright ©. All rights reserved. サイトに表示される商標・ロゴ・サービスマークは当社または第三者に帰属します。事前の書面許可なく使用できません。</p>
            <h2>連絡先</h2>
            <p>メール: watch_support@adflash.cn</p>`
        },
        privacy: {
            section1: `        <p>お客様のプライバシー保護は当社にとって重要です。インターネット経由で時折ご提供いただくことのある個人を特定できる情報を当社がどのように取り扱うかを説明します。</p>
            <p>当社のアプリおよび関連サービスに基づき、第三者が提供する特別機能サービスの利用を申請できる場合があります。特別機能サービスを利用するには、その利用規約をよくお読みください。受諾または利用により、本規約および当該サービス規約を読み、同意し、拘束されることに同意したものとみなされます。</p>
            <p>ご依頼のサービス提供に必要な場合、情報が必要となることがあります。本プライバシー声明は当該製品に適用されます。</p>
            <h2>チームが収集・受領する情報</h2>
            <p>ソフトウェアとサービスを利用する際、当社は自動的に以下の情報を収集・保存する場合があります：</p>
            <p>1. 技術情報。お客様のデバイス、ソフトウェアとサービス、他の第三者ソフトウェア（「他のソフトウェア」）の利用に関する技術情報（OSおよび他のソフトウェアの種類/名称/バージョン、相互作用、ISP、位置情報（GPS）、IPアドレス、匿名ユーザー識別子、デバイス構成・識別子（IDFA、Advertising IDなど）、ソフトウェアとサービスのバージョン、構成・設定など）。</p>
            <p>2. 利用情報。デバイス、ソフトウェアとサービス、他のソフトウェアの利用・相互作用に関する情報（保有アプリ、使用頻度、閲覧・利用した広告、利用方法・反応など）。</p>
            <p>3. ソーシャルネットワーク。ソフトウェアとサービスを通じたソーシャルネットワーク上でのやり取り；</p>`,
            section2: `        <p>4. 登録関連情報。登録時に提供される情報（氏名、住所、メール、電話・FAX、生年月日、性別など）。</p>
            <p>5. サポート関連情報。サポート欄やメールで当社と連絡する場合、メールアドレス、氏名、任意で提出された情報を収集する場合があります。ソフトウェアとサービスを利用する際、匿名の内部ユーザーID（「ユーザーID」）を生成し、上記情報と組み合わせる場合があります。</p>
            <p>6. デバイス情報</p>
            <p>ハードウェアモデル、OSとバージョン、一意のデバイス識別子（SSAAD、GAIDを含む）、ブラウザ種別と言語、携帯電話番号、モバイルネットワーク情報、IMEI、IDFA、IDFV、ICCID、MACアドレス、モデルと解像度を収集します。これは製品・サービスの利用デバイス数の算出、機種別・描画適応のデータ分析に用います。一部情報を提供しない場合、アプリの多くを活用できないことがあります。障害発生時の診断のため一部デバイス情報も収集します。</p>
            <p>7. カメラと写真</p>
            <p>多くのサービスでは、デバイスのカメラや写真から画像等を収集する必要があります。お客様の同意後にのみアクセスします。提供されない場合、多くのサービスを利用できないことがあります。</p>
            <p>8. ローカルストレージ</p>
            <p>ブラウザのWebストレージ（HTML5を含む）やアプリデータキャッシュ等の仕組みで、デバイスにローカル保存する場合があります。保存情報は第三者と共有しません。</p>
            <p>9. 非個人情報</p>`,
            section3: `        <p>    非個人情報とは、特定個人を直接識別できない形式のデータ（Android ID、CPNモデル、メモリ容量、電話のIMEI、機種、ROM、インストールアプリ名・パッケージ名、通信事業者、位置、インストール/アンインストール、使用頻度等）を指します。</p>
            <p>    ユーザー行動の理解、問題解決、製品・サービス・広告の改善のため、非個人情報（インストールアプリ名・パッケージ名、インストールデータ、使用頻度、国、デバイス、チャネル等）を収集・利用する場合があります。</p>
            <h2>チームが情報を利用する方法</h2>
            <p>チームは以下の分析・事業・運用目的で情報を利用する場合があります：</p>
            <p>1. ソフトウェアとサービスを運用・更新し、既存・新機能を提供するため；</p>
            <p>2. ソフトウェアとサービスを改善・カスタマイズするため；</p>
            <p>3. パーソナライズされたコンテンツ（当社またはパートナーによる関心に基づく広告の提供を含む）を提供するため；</p>
            <p>4. 品質と運用の維持・改善のため；</p>
            <p>5. アップデートを通知するため；</p>
            <p>6. サポート提供、苦情・フィードバック対応のため；</p>
            <p>7. サービスに関連する紛争における対応のため；</p>`,
            section4: `        <p>8. 規約の執行および不法行為・濫用の防止のため；</p>
            <p>9. 関連法令、法的手続または政府の要請に従うため。第三者との情報共有。</p>
            <h2>児童のプライバシー</h2>
            <p>本サービスは13歳未満を対象としていません。13歳未満の個人情報を収集したことが判明した場合、直ちに削除します。保護者の方でお子様が個人情報を提供したことを把握された場合はご連絡ください。</p>
            <h2>本プライバシーポリシーの変更</h2>
            <p>本ポリシーは随時更新されることがあります。定期的な確認をお勧めします。変更は本ページに掲載し、掲載直後から有効となります。</p>
            <h2>お問い合わせ</h2>
            <p>返金に関するお問い合わせは Email: watch_support@adflash.cn までご連絡ください</p>`,


        },
        refund: {
            section1: `<p>ご購入ありがとうございます。ご購入に完全にご満足いただけない場合、サポートいたします。</p>
            <p>返金手続きを開始するには、以下の手順に従ってください。</p>
            <p>サブスクリプション商品（例：ベーシックサブスクリプション）</p>
            <p>利用を停止したが解約を忘れた場合、支払い後にセッションの利用や画像生成がなければ、通常は直近の支払いを返金いたします。</p>
            <p>返金を依頼するには、アカウントおよびフィードバックフォームから返金リクエストを送信してください。本人確認のため、追加情報をお願いする場合があります。</p>
            <p>デジタル商品（例：回数パック、サブスクリプション）</p>
            <p>回数パックやサブスクリプションを一部でも使用した場合は返金対象外です。部分・日割り返金は提供していません。</p>
            <p>取引日から14日以内に返金を申請できます。</p>
            <p>返金リクエストを受領後、スタッフが会員ステータスを確認し、返金可否を判断します。</p>`,
            section2: `<p>承認された場合、返金処理を行います。返金は購入時の元の【支払い方法】に入金されます。</p>
            <p>返金の遅延または未着</p>
            <p>返金が確認できない場合、まず銀行口座を再確認してください。</p>
            <p>その後、カード会社にお問い合わせください。返金の正式な反映まで時間がかかる場合があります。</p>
            <p>次に銀行にお問い合わせください。返金が反映されるまで処理時間を要することがあります。</p>
            <p>それでも返金が確認できない場合は、watch_support@adflash.cn までご連絡ください。</p>
            <p>セール品</p>
            <p>通常価格の商品に限り返金可能であり、セール品は返金対象外です。</p>`,
        },
        us: {
            section1: `<p>会社情報</p>
            <p>名称：HONG KONG ADFLASH MEDIA LIMITED</p>
            <p>住所：RM 1101 11/F SAN TOI BUILDING NO.139 CONNAUGHT ROAD CENTRAL HK</p>
            <p>メール：watch_support@adflash.cn</p>`,
        },
        zhznService: {
            section1: `<h1>サービス利用規約</h1>
    最終更新日：2024年6月12日<br>
    本サービスをご利用になる前に、本規約をよくお読みください。<br>
`,
            section2: `<h1>解釈と定義</h1>
    <h1>解釈</h1>
    先頭が大文字の語は、以下の条件に基づき定義された意味を持ちます。
    単数・複数の別なく同じ意味を持ちます。
    <br>`,
            section3: `    <h1>定義</h1>
    本規約において：
    - アプリケーション：お客様が任意の電子機器で使用する、当社が提供するソフトウェアプログラム。<br>
    - アカウント：本サービスまたはその一部にアクセスするために作成された一意のアカウント。<br>
    - 会社（本契約において「当社」「私たち」など）：HONG KONG ADFLASH MEDIA LIMITED を指す。<br>
    - コンテンツ：お客様が投稿、アップロード、リンク、その他の方法で利用可能にするテキスト、画像、その他の情報。<br>
    - デバイス：本サービスにアクセスできる、時計、携帯電話、タブレット等の機器。<br>
    - フィードバック：本サービスの属性、性能、機能に関してお客様が送る意見、革新、提案。<br>
    - 商品：本サービスで販売される品目。<br>
    - 注文：当社から商品を購入するためのリクエスト。<br>
    - サービス：アプリケーションを指す。<br>
    - サブスクリプション：当社が提供する、サブスクリプションに基づくサービスまたはアクセス権。<br>
    - 無料トライアル：サブスクリプション購入時に無償で提供される期間。<br>
    - 規約：本サービス利用に関してお客様と当社の間の完全な合意を構成する本規約。<br>
    - お客様：本サービスにアクセスまたは使用する個人、またはその代理の法人等。<br>`,
            section4: `<h1>承諾</h1>
    本規約は本サービスの利用を規定するものであり、お客様と当社の間の合意です。本規約はすべてのユーザーの権利と義務を定めます。<br>
    本サービスへのアクセス・利用は、本規約の受諾と遵守を条件とします。本規約はすべての訪問者、ユーザーに適用されます。<br>
    また、本サービスへのアクセス・利用は、当社のプライバシーポリシーの受諾と遵守も条件となります。プライバシーポリシーは、アプリまたはウェブサイト利用時の個人情報の収集、使用、開示に関する方針を説明します。ご利用前に必ずお読みください。<br>`,
            section5: `    <h1>サービス内容</h1>
    快適にご利用いただくため、以下のユーザー規約をよく読み、遵守してください。<br>
    <h2>1. サービス中断の免責</h2>
    a. 本アプリの一部機能は OPENAI のサービスに依存します。OPENAI のシステム停止等により体験が影響を受けた場合、解決に努めますが、直接の責任は負いません。<br>
    b. 本アプリはユーザーの所在地の法令に従って運営されます。法令変更により提供継続が困難となった場合、速やかに調整しますが、責任は負いません。<br>
    c.  3. 当社は一定回数の無料利用を提供します。不足と感じられても、これはAIサービスの既定の無料利用枠であることをご理解ください。<br>
    <h2>2. ネットワーク接続の問題</h2>
    円滑な利用のため、安定したネットワーク接続と良好なハードウェア性能を推奨します。一部機能は高速で信頼性の高いインターネット接続と十分な伝送速度に依存します。不安定な接続や低速、利用不能による不便については責任を負いません。<br>
    <h2>3. アプリサービスとネットワークの問題</h2>
    a. 技術的・その他の制御不能な要因により、一時的な中断や利用不能が発生し得ます。ご報告後、復旧のため支援します。<br>
    b. ネットワークの変動や設定誤りにより、アプリとデバイスの接続が切れる場合があります。正しいペアリング設定と安定したネットワークを推奨します。ガイドとオンラインサポートを提供しますが、第三者要因による中断については責任を負いません。<br>
    c.   3. 本アプリは安定したインターネット接続を必要とします。問題発生時はカスタマーサポートが改善を支援します。<br>
    <h2>4. 音声認識率の期待差</h2>
    本アプリの音声認識技術は厳密にテストされていますが、技術的制限等により、認識率や結果が期待に満たない場合があります。結果にご満足いただけない場合も改善に努めますが、結果に対する責任は負いません。<br>
    上記条項に関するご質問や技術サポートは、カスタマーサービスへご連絡ください。<br>
    メール：aisupport@adflash.cn<br>`,
            section6: `<h1>商品注文</h1>
    本サービスを通じて商品を注文することで、法的に拘束力のある契約を締結する能力があることを保証します。<br>`,
            section7: `<h1>お客様の情報</h1>
    注文の際、クレジットカード番号、有効期限、請求先住所、配送情報など、関連情報の提供をお願いすることがあります。<br>
    (i) 当該決済手段を使用する正当な権利があり、(ii) 提供情報が真実・正確・完全であることを表明・保証します。<br>
    これらの情報を送信することで、決済処理のために第三者決済業者へ提供する権利を当社に付与します。<br>`,
            section8: `<h1>注文のキャンセル</h1>
    以下の理由等により、当社はいつでも注文を拒否またはキャンセルする権利を留保します：<br>
    - 商品の在庫状況<br>
    - 商品説明や価格の誤り<br>
    - お客様の注文内容の誤り<br>
    詐欺、無許可または違法な取引が疑われる場合も、注文を拒否またはキャンセルできます。<br>`,
            section9: `<h1>在庫、誤り、不正確さ</h1>
    当社は本サービス上の商品提供を継続的に更新しています。本サービス上の商品が誤価格、不正確な説明、在庫切れの場合があり、情報更新に遅延が生じることがあります。<br>
    価格、商品画像、仕様、在庫、サービスなどの情報の正確性や完全性は保証しません。事前通知なく、いつでも情報の変更・更新・誤りの訂正を行う権利を有します。<br>`,
            section10: `<h1>価格ポリシー</h1>
    会社は、注文受領前であればいつでも価格を改定する権利を有します。<br>
    受領後であっても、政府の措置、関税の変更、送料の増加、為替コストの上昇、その他の不可抗力により価格が改定される場合があります。その場合、お客様は注文をキャンセルする権利を有します。<br>`,
            section11: `<h1>支払い</h1>
    すべての商品は一回の支払いが必要です。Visa、MasterCard、オンライン決済（例：PayPal）など、利用可能な決済方法で支払えます。<br>
    カード（クレジット/デビット）は発行会社の確認と承認を受ける必要があります。承認されない場合、遅延や未配送について当社は責任を負いません。<br>`,
            section12: `<h1>サブスクリプション</h1>
    <h1>サブスクリプション期間</h1>
    本サービスの全部または一部は有料サブスクリプションでのみ利用可能です。選択したプランに応じて、事前に定期的（例：日次、週次、月次、年次）に請求されます。<br>
    各期間の終了時に、お客様が解約しない限り、同条件で自動更新されます（当社が解約する場合を除く）。<br>`,
            section13: `<h1>返金</h1>
    法律で要求される場合を除き、有料のサブスクリプション料金は返金不可です。<br>
    一部の返金リクエストは、個別に検討され、会社の裁量で承認される場合があります。<br>`,
            section14: ` <h1>支払い条件</h1>
    円滑な決済と透明性のため、以下をよくお読みください。<br>
    1. 決済の円滑な進行のため、ユーザーはネットワークとハードウェアの正常動作を確保する責任を負います。ユーザー側のネットワーク不安定や機器不具合による決済失敗について、当社は責任を負いません。<br>
    2. カード組織のリスク管理により決済が拒否される場合があり、当社は責任を負いません。決済前に発行銀行へ利用状況や制限をご確認ください。<br>
    3. 本アプリの決済機能は第三者プラットフォームの支援に依存する場合があります。第三者の障害・サービス停止による決済失敗に対して、当社は連携と支援に努めますが、責任は負いません。問題が生じた場合はいつでもカスタマーサポートにご連絡ください。<br>
    4. ユーザーが月額サブスクリプションを自発的に選択・確定した後、ユーザーセンターで購読状況と利用記録を確認・管理できます。個人的な選択に基づく定期課金に関する苦情について、当社は責任を負いません。<br>
    5. 購入後にサービスの利用が開始された場合、原則として返金には応じません。購入前に規約をよく読み、不明点はカスタマーサポートにお問い合わせください。<br>
    6. 関連法規または規制措置の影響で決済が失敗した場合、当社は関連情報の提供と解決支援に努めますが、最終的な責任は現地法令の遵守にあります。<br>
    お問い合わせ：<br>
    - メール：aisupport@adflash.cn<br>`,
            section15: `<h1>ユーザーアカウント</h1>
    アカウント作成時には、常に正確・完全・最新の情報を提供してください。違反時は直ちにアカウントが停止される場合があります。<br>
    パスワードの保護と、そのパスワードの下で行われる活動に対する責任はお客様にあります。<br>
    パスワードを第三者に開示しないでください。セキュリティ侵害や不正利用に気付いた場合は直ちに通知してください。<br>
    他人の氏名・権利の対象となる名称・不快/卑猥な名称をユーザー名として使用できません。<br>`,
            section16: `<h1>著作権ポリシー</h1>
    <h1>知的財産の侵害</h1>
    当社は他者の知的財産権を尊重します。サービスに掲載されたコンテンツが著作権等を侵害しているとの申し立てには対応します。<br>
    著作権者またはその代理人である場合、侵害の詳細を含む書面通知を、当社の著作権代理人宛に提出してください。<br>
    侵害の虚偽申立てを行った場合、損害賠償責任を負う場合があります。<br>`,
            section17: `<h1>DMCA 通知および手続</h1>
    DMCA に基づく通知は、以下の情報を含む書面を当社の著作権代理人に提出してください（17 U.S.C 512(c)(3) 参照）：<br>
    - 権利者代理の電子/物理署名<br>
    - 侵害されたと主張する著作物の説明（URL または写し）<br>
    - 侵害資料が存在する本サービス上のURLまたは特定位置<br>
    - 住所、電話番号、メールアドレス<br>
    - 当該使用が権利者・代理人・法により許可されていないとの誠実な信念の陳述<br>
    - 上記情報が正確であり、偽証の罰則の下で、権利者またはその代理であることの陳述<br>
    連絡先（著作権代理人）：aisupport@adflash.cn<br>
    通知受領後、当社は適切と判断する措置（当該コンテンツの削除等）を講じます。<br>`,
            section18: `<h1>知的財産</h1>
    本サービスおよびそのオリジナルコンテンツ（お客様や他ユーザー提供分を除く）、機能は当社およびライセンサーの独占的財産です。<br>
    本サービスは国内外の著作権法、商標法等により保護されています。<br>
    当社の商標やトレードドレスは、事前の書面許可なく使用できません。<br>`,
            section19: `<h1>お客様からのフィードバック</h1>
    お客様は提供したフィードバックに関するすべての権利・権原・利益を当社に譲渡します。譲渡が無効な場合、当社に対して、非独占的、永続的、取消不能、ロイヤリティフリー、世界的な使用・複製・開示・サブライセンス・配布・改変・利用の権利を付与します。<br>`,
            section20: `<h1>終了</h1>
    当社は理由の如何を問わず、事前通知なく直ちにお客様のアカウントを終了または停止できます（本規約違反を含む）。<br>
    終了後、お客様の本サービスの利用権は直ちに消滅します。アカウントを終了したい場合は、本サービスの利用を中止してください。<br>`,
            section21: `<h1>責任の制限</h1>
    お客様に生じ得るいかなる損害にもかかわらず、当社およびサプライヤーの責任は、本サービスを通じてお客様が実際に支払った額、または購入がない場合はゼロに限定されます。<br>
    法の許す最大限の範囲で、当社またはサプライヤーは、利益・データの喪失、業務中断、人的損害、プライバシー侵害、第三者ソフトウェア/ハードウェアとの関連等に起因する特別・付随・間接・結果的損害について責任を負いません。<br>
    一部の州では黙示保証の除外や結果的損害の責任制限を認めていないため、適用されない場合があります。<br>`,
            section22: `<h1>「現状有姿」および「提供可能な状態」の免責</h1>
    本サービスはあらゆる欠陥を含む「現状有姿」および「提供可能な状態」で提供されます。適用法の最大限の範囲で、当社および関連会社・ライセンサーは、商品性、特定目的適合性、権原、非侵害、取引過程・実績・慣習に基づく保証を含む、一切の保証を否認します。本サービスがお客様の要件を満たすこと、意図する結果を達成すること、他ソフト・アプリ・システム・サービスと互換性があること、中断なく動作すること、信頼性や性能基準を満たすこと、エラーがないこと、エラーが修正されることを保証しません。<br>
    当社や提供者は、(i) サービスの運用・可用性、情報・コンテンツ・素材・製品に関する表示、(ii) 中断やエラーの不存在、(iii) 情報の正確性・信頼性・最新性、(iv) サービス・サーバー・コンテンツ・当社名義のメールにウイルスやマルウェア等の有害要素がないことを表明または保証しません。<br>
    一部法域では特定の保証の除外や消費者の法定権利に対する制限を認めていないため、上記の一部または全部が適用されない場合があります。その場合でも、可能な限り最大限に本条の除外・制限が適用されます。<br>`,
            section23: ` <h1>準拠法</h1>
    抵触法規定を除く当該国の法が本規約および本サービスの利用を規律します。アプリの利用はその他の法の適用を受ける場合があります。<br>`,
            section24: `<h1>紛争解決</h1>
    本サービスに関する懸念や紛争がある場合、まず当社へ連絡し、非公式に解決を試みることに同意します。<br>`,
            section25: ` <h1>EU（欧州連合）のユーザー向け</h1>
    EU消費者は、居住国の強行規定から利益を受けます。<br>`,
            section26: `<h1>米国連邦政府エンドユーザー規定</h1>
    お客様が米国連邦政府のエンドユーザーである場合、本サービスは48 C.F.R. 2.101 に定義される「商用品目です」。<br>`,
            section27: `<h1>米国法令遵守</h1>
    お客様は、(i) 米国政府の禁輸対象国またはテロ支援国に所在せず、(ii) 米国政府の禁止・制限対象者リストに記載されていないことを表明・保証します。<br>`,
            section28: `<h1>可分性および権利不行使</h1>
    <h1>可分性</h1>
    本規約の条項が執行不能・無効と判断された場合、その目的が最大限達成されるよう解釈・変更され、残りの条項は引き続き有効です。<br>`,
            section29: `<h1>権利不行使</h1>
    本規約に基づく権利の不行使または義務履行の要求の欠如は、将来の権利行使や要求を妨げず、違反の放棄は以後の違反の放棄を意味しません。<br>`,
            section30: `<h1>翻訳の解釈</h1>
    本規約は翻訳されて提供される場合があります。<br>
紛争が生じた場合は英語原文が優先します。<br>`,
            section31: `<h1>本規約の変更</h1>
当社は裁量により、いつでも本規約を変更または置換できます。重要な変更の場合は、発効の少なくとも30日前までに合理的な努力で通知します。重要か否かの判断は当社の裁量によります。<br>
変更発効後も本サービスの利用を継続することで、変更後の規約に同意したものとみなされます。不同意の場合は利用を停止してください。<br>`,
            section32: `<h1>お問い合わせ</h1>
本規約についてのご質問は以下までご連絡ください：<br>
- メール：aisupport@adflash.cn`
        },
        zhznPrivacy: {
            section1: ` <h2>プライバシーポリシー</h2>
                <p>お客様のプライバシー保護は重要です。インターネットを通じて提供される可能性がある個人識別情報を当社がどのように取り扱うかを説明します。</p>
                <p>当社のアプリおよび関連サービスに基づき、特別機能サービスの利用を申請できる場合があります。特別機能サービスを利用する場合は、その利用規約をよくお読みください。  </p>
                <p>特別機能サービスを受け入れ、または利用することで、本規約および当該サービス規約を読み、同意し、それらに拘束されることに同意したものとみなされます。</p>
                <p>ご要望のサービス提供のため、時に情報が必要となることがあります。本プライバシー声明は当該製品に適用されます。</p>`,
            section2: `<h2>チームが収集・受領する情報</h2>
                <p>ソフトウェアおよびサービスを利用する際、当社は以下の情報を自動的に収集・保存する場合があります：</p>
                <p>ソフトウェアとサービスの安全な運用、品質、効率を確保するため、実際の必要に応じて、システムバージョン、デバイス識別子（Android の AndroidID、iOS の VendorID など。識別子の有効期間、ユーザーによるリセット可否、取得方法は異なる場合があります）、ネットワーク機器のハードウェアアドレス（デバイスの MAC アドレス）、解像度を収集することがあります。</p>
                <p>悪意あるプログラムの防止と運用品質・効率の確保のため、実行プロセス、ページ全体の動作、使用状況・頻度、ページクラッシュ、全体的な使用量、パフォーマンスデータを収集します。</p>`,
            section3: `<h2>チームが情報を利用する方法</h2>
        
                <p>チームは以下の分析・事業・運用目的で情報を利用する場合があります：</p>
                <p>- ソフトウェアとサービスを運用・更新し、既存/新機能を提供するため；</p>
                <p>- ソフトウェアとサービスを改善・カスタマイズするため；</p>
                <p>- パーソナライズされたコンテンツを提供するため；</p>
                <p>- ソフトウェアとサービスの品質と運用を維持・改善するため；</p>
                <p>- ソフトウェアとサービスの更新を通知するため；</p>
                <p>- サポートを提供し、苦情やフィードバックに対応するため；</p>
                <p>- サービスに関連する紛争が発生した場合に対応するため；</p>
                <p>- 規約を執行し、不法行為や不正使用を防止するため；</p>
                <p>- 関連法令、法的手続き、または政府の要請に従うため。第三者との情報共有。</p>

                <p>当社はお客様の個人情報の安全確保に努め、製品・サービス提供に必要な期間のみ保有し、必要性を超えて保有しません。例：</p>
                <p>- MAC アドレス：正常なサービス提供、問い合わせ・苦情対応、アカウント・システムの安全確保のため、継続的な保有が必要です。</p>
                <p>- サブスクリプション決済関連トークン：関連サブスクリプションサービスの提供のため。</p>
                <p>- 法令に基づく情報の保管要件遵守。</p>
                <p>- 財務、監査、紛争解決等のための合理的な期間延長。</p>`,
            section4: `<h2>児童のプライバシー</h2>

                <p>当社は児童の個人情報を故意に収集しません。児童から個人情報の提供があったことを知り得た場合、直ちにサーバーから削除します。保護者の方で、児童が情報を提供したことをご存じの場合はご連絡ください。</p>`,
            section5: `<h2>本プライバシーポリシーの変更</h2>
                
                <p>本ポリシーは随時更新されることがあります。定期的に本ページをご確認ください。変更は本ページへの掲載をもって通知し、掲載直後から有効です。</p>`,
            section6: ` <h2>本プライバシーポリシーの変更</h2>
                
                <p>本ポリシーは随時更新されることがあります。定期的に本ページをご確認ください。変更は本ページへの掲載をもって通知し、掲載直後から有効です。</p>`,
            section7: `<h2>お問い合わせ</h2>

                <p>本プライバシーポリシーに関するご質問やご提案は、以下までご連絡ください：</p>
                <p>aisupport@adflash.cn</p>`
        }
    }
}
